import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolErrorIndicator } from '../ChatMessage/indicators/ChatToolErrorIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import { I18nNamespace } from '~/common/types';

import { ToolResultComponent } from '.';

export const IdentifyCommodityGroupTool: ToolResultComponent<
  Tool.identifyCommodityGroup,
  { contents: string[] },
  { success: true } | { success: false; error: string }
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });
  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t(`call`, { count: tool.input?.contents?.length ?? 0 })} />;

    case 'output-available': {
      if (!tool.output.success) {
        return <ChatToolErrorIndicator message={t('error', { count: tool.input.contents.length })} />;
      }
      return <ChatToolResultIndicator message={t(`result`, { count: tool.input.contents.length })} />;
    }
  }
};
